export const abouts = [
	{
		id: 1,
		imgUrl:
			'https://raw.githubusercontent.com/omarbagna/portfolioImages/main/aboutImg01.png',
		title: 'UI Design',
		content:
			'I am good at designing fully responsive websites following best design principles.',
	},
	{
		id: 2,
		imgUrl:
			'https://raw.githubusercontent.com/omarbagna/portfolioImages/main/aboutImg02.png',
		title: 'FrontEnd Development',
		content:
			'I am a Fullstack developer with a passion for building beautiful and responsive websites and Apps.',
	},
	{
		id: 3,
		imgUrl:
			'https://raw.githubusercontent.com/omarbagna/portfolioImages/main/aboutImg03.png',
		title: 'Python Automation',
		content:
			'I write very comprehensive and powerful python automation scripts for web scraping and testing.',
	},
];

export const experience = [
	{
		id: 1,
		year: 2022,
		work: {
			name: 'Backend Developer',
			company: 'Heritors Labs Limited',
			desc: 'I helped to design a new website with fullstack capabilities',
		},
	},
	{
		id: 2,
		year: 2022,
		work: {
			name: 'Python Programmer',
			company: 'Built Accounting',
			desc: 'I wrote automation scripts to scrape various websites for useful data.',
		},
	},
	{
		id: 3,
		year: 2021,
		work: {
			name: 'Frontend Developer',
			company: 'NumberPal',
			desc: 'I designed and deployed a company website for NumberPal',
		},
	},
];

export const skill = [
	{
		name: 'Python',
		icon: 'https://raw.githubusercontent.com/omarbagna/portfolioImages/main/python.png',
	},
	{
		name: 'Illustrator',
		icon: 'https://raw.githubusercontent.com/omarbagna/portfolioImages/main/illustrator.png',
	},
	{
		name: 'HTML',
		icon: 'https://raw.githubusercontent.com/omarbagna/portfolioImages/main/html.png',
	},
	{
		name: 'Figma',
		icon: 'https://raw.githubusercontent.com/omarbagna/portfolioImages/main/figma.png',
	},
	{
		name: 'React',
		icon: 'https://raw.githubusercontent.com/omarbagna/portfolioImages/main/react.png',
	},
	{
		name: 'JavaScript',
		icon: 'https://raw.githubusercontent.com/omarbagna/portfolioImages/main/javascript.png',
	},
];

export const testimonials = [
	{
		imgUrl:
			'https://raw.githubusercontent.com/omarbagna/portfolioImages/main/sinka.png',
		feedback: 'Vitalik-Hakim makes my UI designs come to life',
		name: 'Obed',
		company: 'Obed Opoku- UI/UX Designer',
	},
	{
		imgUrl:
			'https://raw.githubusercontent.com/omarbagna/portfolioImages/main/carlton.png',
		feedback: 'A great Developer to work with!',
		name: 'Nana Agyeman',
		company: 'Nana Agyeman-Headboy SOS-HGIC',
	},
];

export const brands = [
	{
		id: '1',
		imgUrl:
			'https://raw.githubusercontent.com/omarbagna/portfolioImages/main/google.png',
		name: 'google',
	},
	{
		id: '2',
		imgUrl:
			'https://raw.githubusercontent.com/omarbagna/portfolioImages/main/github.png',
		name: 'github',
	},
	{
		id: '3',
		imgUrl:
			'https://raw.githubusercontent.com/omarbagna/portfolioImages/main/aws.png',
		name: 'aws',
	},
];

export const work = [
  {
    projectLink: "https://vitalik-hakim.netlify.app/",
    codeLink: "https://github.com/Vitalik-Hakim/antimony",
    imgUrl:
      "https://raw.githubusercontent.com/omarbagna/portfolioImages/main/gpt3Site.png",
    name: "GPT-3",
    title: "Shout Social Network",
    description: "An online community for everyone to join.",
    tags: ["UI/UX", "Web Dev", "React JS"],
  },

  {
    projectLink: "https://vitalik-hakim.netlify.app/",
    codeLink: "https://github.com/Vitalik-Hakim/antimony",
    imgUrl:
      "https://raw.githubusercontent.com/omarbagna/portfolioImages/main/beatsClone.png",
    name: "NFT-SALE",
    title: "NFT-SALE",
    description:
      "This is a Ecommerce shop I built using the Truffle Suite. You can buy items with Etheruem Crypto",
    tags: ["Web Dev", "UI/UX"],
  },
  {
    projectLink: "https://vitalik-hakim.netlify.app/",
    codeLink: "https://github.com/Vitalik-Hakim/antimony",
    imgUrl:
      "https://raw.githubusercontent.com/omarbagna/portfolioImages/main/techsealsImage.png",
    name: "Antimony",
    title: "Antimony Cryptocurrency",
    description:
      "A PoW cryptocurrency core with faster blocktime and lower difficulty. ",
    tags: ["React JS", "Web Dev", "UI/UX", "Python"],
  },
];
